import { logger } from '@gem/modules/logger';

import { IFieldValidationParams, ValidationErrorType } from './fields';

// Needs Bff implementation
export const spaceAliasAsyncValidation = async ({
  errorToText,
}: IFieldValidationParams): Promise<string | null> => {
  try {
    const response = false;

    if ((response as any)?.result === false) {
      return null;
    }
  } catch (error) {
    logger.get('API').error('space.deepLinkExists', error);
  }

  return errorToText[ValidationErrorType.AlreadyExists] || '';
};
